module.exports = __webpack_public_path__ + "static/media/Floor002-04-bg.b2131c26.jpg";